import Vue from 'vue'
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
import { CalendarMathMixin } from "vue-simple-calendar/src/components/bundle";

Vue.component('CalendarView', CalendarView)
Vue.component('CalendarViewHeader', CalendarViewHeader)
Vue.mixin(CalendarMathMixin)
